"use client";

import { c as _c } from "react/compiler-runtime";
import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { useContext } from "timvir/context";
import * as Icons from "../../../../icons";
import { Section } from "./Section";
export function Sidebar(props) {
  const {
    navigation
  } = useContext();
  const {
    usePathname
  } = navigation;
  const pathname = usePathname();
  const [isMenuOpen, setMenuOpen] = React.useState(false);
  React.useEffect(() => {
    const className = {
      className: "x1rife3k xixxii4 x13vifvy xh8yej3"
    }.className;
    if (!className) {
      return;
    }
    const scrollLockClassList = className.split(" ");
    for (const className_0 of scrollLockClassList) {
      document.body.classList.toggle(className_0, isMenuOpen);
    }
    return () => {
      for (const className_1 of scrollLockClassList) {
        document.body.classList.remove(className_1);
      }
    };
  }, [isMenuOpen]);
  const {
    toc,
    search,
    ...rest
  } = props;
  const node_0 = function find(nodes) {
    for (const node of nodes) {
      if (pathname === node.path) {
        return node;
      }
      if (node.children) {
        const n = find(node.children);
        if (n) {
          return n;
        }
      }
    }
  }(toc);
  return <nav {...rest} {...stylex.props(props.sx, styles.root)}>
      <header className="x7uxsod x1pizb70 x78zum5 x6s0dn4 x1d813ht x1m2nq6k x1vptubt">
        <div className="xkpwil5 x1xet1wb x78zum5 xou54vl">
          <div className="xkjxd12">Timvir</div>
          <div className="xuqj7gu x1i1rx1s xmll18r" />
          <div>Docs</div>
        </div>

        {search && <div className="x2lah0s xzhuw26 xw7yly9 x1s85apg x1m2nq6k">
            <Search {...search} />
          </div>}
      </header>

      <button type="button" onClick={() => setMenuOpen(!isMenuOpen)} className="xjbqb8w xln7xf2 x1heor9g xh8yej3 x76ihet xcym7qx x7956lj x1qg66n7 x7uxsod x1pizb70 x78zum5 x6s0dn4 x1ypdohk x1yn2rt8">
        {node_0?.icon ? React.cloneElement(node_0.icon, {
        ...{
          className: "x1lliihq x1fr90bg xpz6ql4 x1db2dqx x15dgqpb"
        }
      }) : null}
        <span>{node_0?.label ?? "Menu"}</span>

        <Icons.Menu width={16} height={16} className="x8x9d4c" />
      </button>

      <div {...{
      0: {
        className: "x1s85apg x1b7vwdu x1j2yrl1 x1azbkut x1fsrbvp xetmjmr x1ccyb2m"
      },
      1: {
        className: "x1b7vwdu x1j2yrl1 x1azbkut x1fsrbvp xetmjmr x1ccyb2m x78zum5 xixxii4 xis09m7 xu96u03 x3m8u43 x1ey2m1c"
      }
    }[!!isMenuOpen << 0]}>
        <div className="x1bd1j73 x1odjw0f x1iyjqo2 xxqldzo xrz96y6 xsgruip">
          <div className="x158hnoc x1ator1a" onClick={() => {
          setMenuOpen(false);
        }}>
            {toc.map((c, i) => <Section key={i} depth={0} {...c} />)}
          </div>
        </div>
      </div>
    </nav>;
}
const styles = {
  root: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kHSMxh: "x1fsrbvp",
    $$css: true
  }
};
function Search(props) {
  const $ = _c(4);
  const {
    open,
    label
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12" className="x1lliihq x1db2dqx x1jw3ynk xvle69y"><path d="M11.707 10.293l-2.54-2.54a5.015 5.015 0 10-1.414 1.414l2.54 2.54a1 1 0 001.414-1.414zM2 5a3 3 0 113 3 3 3 0 01-3-3z" fill="currentColor" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = label || "Search docs";
  let t2;
  if ($[1] !== open || $[2] !== t1) {
    t2 = <div className="xgcpwm9"><button type="button" className="xln7xf2 xh8yej3 x1cdhzux x1dcheo9 x1ylh3l6 xo1l8bm x1ypdohk xu0aao5 xur7f20 x84vhe8 xmkeg23 x1y0btm7 xj7gikm x1d0dlzq x78zum5 x6s0dn4 x1dc5b4e" onClick={open}>{t0}{t1}</button></div>;
    $[1] = open;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}